module.exports = __webpack_public_path__ + "img/keto.6b336863.jpg";